export default "__VITE_ASSET__CZjMnszf__"